import { __decorate, __extends } from "tslib";
import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { SpinnerIcon } from '../../internal/SpinnerIcon';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './Spinner.styles';
import { SpinnerLocaleHelper } from './locale';
var types = {
  big: 'big',
  mini: 'mini',
  normal: 'normal'
};

var Spinner =
/** @class */
function (_super) {
  __extends(Spinner, _super);

  function Spinner(props) {
    var _this = _super.call(this, props) || this;

    _this.renderCloud = function (type) {
      var dimmed = _this.props.dimmed;
      var cloudClassName = dimmed ? jsStyles.cloudDimmed(_this.theme) : jsStyles.cloud(_this.theme);
      return React.createElement("span", {
        className: jsStyles.cloudWrapper()
      }, React.createElement(SpinnerIcon, {
        dimmed: dimmed,
        size: type,
        className: cloudClassName,
        strokeClassName: jsStyles.cloudStroke(_this.theme)
      }));
    };

    _this.renderCircle = function () {
      var theme = _this.theme;
      var dimmed = _this.props.dimmed;
      var circleClassName = dimmed ? jsStyles.circleDimmed(theme) : jsStyles.circle(theme);
      return React.createElement(SpinnerIcon, {
        dimmed: dimmed,
        size: "mini",
        className: circleClassName
      });
    };

    _this.renderSpinnerOld = function (type) {
      return type === 'mini' ? _this.renderCircle() : _this.renderCloud(type);
    };

    _this.renderCaption = function (type, caption) {
      return React.createElement("span", {
        className: cn(jsStyles[type](_this.theme), jsStyles.captionColor(_this.theme))
      }, caption);
    };

    return _this;
  }

  Spinner.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return _this.renderMain();
    });
  };

  Spinner.prototype.renderMain = function () {
    var _a = this.props,
        type = _a.type,
        _b = _a.caption,
        caption = _b === void 0 ? this.locale.loading : _b;
    return React.createElement("div", {
      className: jsStyles.spinner()
    }, React.createElement("span", {
      className: jsStyles.inner()
    }, this.renderSpinnerOld(type)), caption && this.renderCaption(type, caption));
  };

  Spinner.__KONTUR_REACT_UI__ = 'SpinnerOld';
  Spinner.propTypes = {
    /**
     * Текст рядом с мини-лоадером.
     *
     * 'Загрузка' - значение по-умолчанию
     */
    caption: PropTypes.node,
    dimmed: PropTypes.bool,

    /**
     * Тип спиннера: mini, normal, big
     *
     * Значение по-умолчанию - normal
     *
     * SpinnerOld.types - все доступные типы
     */
    type: PropTypes.oneOf(Object.keys(types))
  };
  Spinner.defaultProps = {
    type: 'normal'
  };
  Spinner.Types = types;
  Spinner = __decorate([locale('Spinner', SpinnerLocaleHelper)], Spinner);
  return Spinner;
}(React.Component);

export { Spinner };